<template>
  <div class="vue-sidebar flex-column col-lg-2 sidebar" :style="openSidebarStyle">
    <artist-sidebar v-if="artist" v-bind="$data" :artist="artist" :songs="songs" :url-prefix="(artist && artist.is_shared) ? '/shared' : ''"/>
    <regular-sidebar v-else v-bind="$data" :songs="songs"/>
  </div>
</template>

<style scoped>
  .vue-sidebar {
    display: none;
  }

  @media ( min-width: 992px ) {
    .vue-sidebar {
      display: flex;
    }
  }

  .no-sidebar .vue-sidebar {
    display: none !important;
  }
</style>

<script>
import ArtistSidebar from "./sidebar_artist_view.vue"
import RegularSidebar from "./sidebar_regular_view.vue"
import store from "./sidebar_store.js"

export default {
  props: [ "sidebarOpen" ],
  components: { ArtistSidebar, RegularSidebar },
  data() {
    const sd = window.mbPreload?.sidebar || {}
    return {
      userRole: sd.userRole || "guest",
      artists: sd.artists || [],
      playlists: sd.playlists || [],
    }
  },
  computed: {
    openSidebarStyle() {
      if ( !this.sidebarOpen )
        return {}
      else
        return { display: "flex" }
    },
    artist() {
      if ( this.$route.params.artistID ) {
        return store.artists.find(a => a.id == this.$route.params.artistID)
      } else if ( this.$route.params.songID ) {
        return store.artistForSongID(this.$route.params.songID)
      } else {
        return undefined
      }
    },
    songs() {
      return store.songs
    }
  },
  watch: {
    "$route"(to, _) {
      if ( to.params.artistID )
        store.fetchSongsForArtist(to.params.artistID)

      this.$emit("close-sidebar")
    }
  },
  created() {
    store.init()
  }
}
</script>
